import React, { useState, useMemo } from 'react';
import { Viewer } from '@tencent/spaui';

type ContentType = 'image' | 'video' | 'file' | 'link';

const useContentPreview = (props: {
  useImagePreivew?: Boolean,
  viewerProps?: Record<string, any>,
} = {}) => {
  const { useImagePreivew = true, viewerProps = {} } = props;
  const [showImage, setShowImage] = useState(false);
  const [viewerType, setViewerType] = useState<'images' | 'content'>('images');
  const [imageData, setImageData] = useState<Array<string>>([]);
  const [videoUrl, setVideoUrl] = useState('');

  const imageViewer = useMemo(() => (useImagePreivew
    ? (
    <Viewer
      type={viewerType}
      show={showImage}
      data={imageData}
      onClose={() => setShowImage(false)}
      {...viewerProps}
    >
      {videoUrl
        ? <video controls width="600" height="400">
            <source src={videoUrl} />
            <p>浏览器不支持视频播放，<a href={videoUrl} target="_blank" rel="noreferrer">点击打开视频链接</a></p>
          </video>
        : null}
    </Viewer>
    ) : null), [useImagePreivew, viewerProps]);

  const contentPreview = (type: ContentType, url: string) => {
    if (!url) return;
    switch (type) {
      case 'image':
        setViewerType('images');
        setImageData([url]);
        setShowImage(true);
        break;
      case 'video':
        setViewerType('content');
        setVideoUrl(url);
        setShowImage(true);
        break;
      default:
        window.open(url);
        break;
    }
  };

  return {
    contentPreview,
    imageViewer,
  };
};

export default useContentPreview;
